export const selectCurrentUser = (state: any) => state.currentUser.currentUser;
